<template>
    <div style="position: relative;">
      <div class="module-title">
        <h3>获得荣誉</h3>
        <p class="small-text">gain honor</p>
      </div>
      <div class="container">
        <el-carousel height="320px" style="width: 100%;">
          <el-carousel-item v-for="(item, index) in honorList" :key="index">
            <div class="honor-list">
              <div v-for="cItem in item" :key="cItem.id" class="honor-item">
                <img :src="cItem.fileUrl" :alt="cItem.name" class="honor-img" @click="onHonorClick(cItem)" />
                <p class="honor-title">{{cItem.name}}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="position-bg"></div>
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted} from 'vue'
import { useHttpApi } from '~/composables/useApi'
import { ElCarousel, ElCarouselItem } from 'element-plus'

const honorList = ref([])
const { getHonorListApi } = useHttpApi()
const getHonorList = async () => {
  const res = await getHonorListApi()
  const val = res?.data?.data
  //分割res.data.data,每3个一放一个数组中，然后把数组放到一个二维数组中
  for (let i = 0; i < val.length; i += 3) {
    honorList.value.push(val.slice(i, i + 3))
  }
}

const onHonorClick = (item: any) => {
  if (!item.linkUrl) return;
  window.open(item.linkUrl, '_blank')
}
onMounted(() => {
  getHonorList()
})
</script>
<style lang="scss" scoped>
.honor-list {
  position: relative;
  display: flex;
  gap: 30px;
  padding: 0 70px;
  &::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 45px;
    width: 75px;
    height: 110px;
    background: url("@/assets/images/honor/icon01.png") no-repeat center/cover;
    z-index: 1;
  }
  &::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 45px;
    width: 75px;
    height: 110px;
    background: url("@/assets/images/honor/icon01.png") no-repeat center/cover;
    transform: scaleX(-1);
    z-index: 1;
  }

  .honor-item {
    position: relative;
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    z-index: 2;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
    &:hover {
      transform: translateY(-10px);
    }
    .honor-img {
      width: 100%;
      height: 225px;
      object-fit: cover;
      border-radius: 10px;
      border: solid 5px #fff;
    }
    .honor-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 500;
      font-size: 18px;
      color: rgba(0,0,0,0.8);

      &::before {
        content: '';
        width: 33px;
        height: 40px;
        background: url("@/assets/images/honor/icon02.png") no-repeat center/cover;
      }
      &::after {
        content: '';
        width: 33px;
        height: 40px;
        background: url("@/assets/images/honor/icon02.png") no-repeat center/cover;
        transform: scaleX(-1);
      }
    }
  }
}
.position-bg {
  position: absolute;
  width: 100%;
  height: 216px;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: #CCDAF7;
}
::v-deep .el-carousel__item, .el-carousel__item.is-active {
  z-index: 9;
}
::v-deep .el-carousel__indicators {
  z-index: 10;
}
</style>